/**
 * CampaignFlowSelector — flow chips (or single name) for the Flows tab.
 * For Media Devoted | Created By Ciro Autiero
 * File edited by By James Alexandrov
 */

import { FC } from "react";

import { cn } from "@/lib/utils";
import type { Flow } from "@/hooks";

interface CampaignFlowSelectorProps {
  flows: Flow[];
  selectedFlowId: string;
  selectedFlowName?: string;
  onSelect: (flowId: string) => void;
}

export const CampaignFlowSelector: FC<CampaignFlowSelectorProps> = ({
  flows,
  selectedFlowId,
  selectedFlowName,
  onSelect,
}) => {
  if (flows.length <= 1) {
    return (
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium text-foreground">
          {selectedFlowName}
        </p>
      </div>
    );
  }

  return (
    <div className="min-w-0 flex-1">
      <div className="flex flex-wrap gap-1.5">
        {flows.map((flow) => {
          const isActive = flow.id === selectedFlowId;
          return (
            <button
              key={flow.id}
              type="button"
              className={cn(
                "max-w-full shrink-0 rounded-md border px-2.5 py-1 text-xs font-medium transition-colors",
                isActive
                  ? "border-primary/30 bg-primary/10 text-primary"
                  : "border-transparent bg-muted/40 text-muted-foreground hover:bg-muted/70 hover:text-foreground",
              )}
              onClick={() => onSelect(flow.id)}
              aria-label={`Select flow ${flow.name}`}
              aria-pressed={isActive}
            >
              <span className="block max-w-[18rem] truncate">{flow.name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CampaignFlowSelector;
